import { useContext, useEffect, useState } from 'react';
import StockPriceTable from './table';
import { axios } from '../../../../../utils/axios';
import { useParams } from 'react-router-dom';
import { CostingRequestsContext } from '../../../../../contexts/CostingRequest';
import { showAlert } from '../../../../../utils/alerts';
import { Button, Grid } from '@mantine/core';
import { AppLoader } from '../../../../../components/common/loader';
import ContentPaper from '../../../../../components/layouts/rfs/Content';

const StockPriceExtension = () => {
  const { crNumber } = useParams();
  const { info } = useContext(CostingRequestsContext);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [priceList, setPriceList] = useState([]);
  const { producing_plant_data, sku_data } = info;
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isStepStarted, setIsStepStarted] = useState(false);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      const plant = splitPlant(producing_plant_data[0].producing_plant);
      setLoading(true);
      const { data } = await axios.post(`/costing-request/stock-price-extension/${crNumber}`, {
        plant: `${plant.letters}**`,
        sku: sku_data[0].sku,
      });
      setIsReadOnly(data.isReadOnly);
      setIsStepStarted(data.isStepStarted);
      setPriceList(data.data);
    } catch (e) {
      showAlert(e, 'error');
    } finally {
      setLoading(false);
    }
  };

  const splitPlant = (plant) => {
    return {
      letters: plant.match(/[A-Za-z]+/)?.[0] || '',
      digits: plant.match(/\d+/)?.[0] || '',
    };
  };

  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      const editablePlants = priceList.filter((plant) => plant.isEditable);

      if (editablePlants.length === 0) {
        showAlert({ message: 'No editable plants to submit' }, 'error');
        return;
      }
      await axios.post(`/costing-request/stock-price-update/${crNumber}`, editablePlants);
      fetch();
      showAlert({ message: 'Stock Price has been updated successfully' }, 'success');
    } catch (e) {
      showAlert(e, 'error');
    } finally {
      setSubmitLoading(false);
    }
  };
  const handleStandardPriceChange = (plantCode, value) => {
    setPriceList((prev) =>
      prev.map((item) =>
        item.plant === plantCode ? { ...item, standard_price: value === null ? '' : value } : item,
      ),
    );
  };

  const Action = () => {
    const hasEditablePlants = priceList.some((p) => p.isEditable);
    return (
    <Grid justify='flex-end'>
      <Grid.Col span={isReadOnly ? 3 : 2}>
        <Button
          variant='gradient'
          color='primary'
          fullWidth
          disabled={submitLoading || priceList.length === 0 || isReadOnly || !hasEditablePlants || !isStepStarted}
          onClick={() => handleSubmit('submit')}
        >
          {isReadOnly ? (
            'Stock Price Extension has already been done'
          ) : submitLoading ? (
            <AppLoader size='sm' />
          ) : (
            'Submit'
          )}
        </Button>
      </Grid.Col>
    </Grid>)
  };

  return (
    <ContentPaper page='stock-price-extension' footer={<Action />}>
      <StockPriceTable
        data={priceList}
        loading={loading}
        handleStandardPriceChange={handleStandardPriceChange}
        isStepStarted={isStepStarted}
      />
    </ContentPaper>
  );
};

export default StockPriceExtension;
